import { ApiService } from './apiService';
import { API_ENDPOINTS } from '../config/api';
import {
  CreateInternalNoteBody,
  InternalNote,
  UpdateInternalNoteBody,
} from '../types/internalNote';

export class InternalNotesService extends ApiService {
  async listNotes(clientUserId: string): Promise<InternalNote[]> {
    return this.get<InternalNote[]>(API_ENDPOINTS.users.internalNotes(clientUserId));
  }

  async createNote(
    clientUserId: string,
    body: CreateInternalNoteBody
  ): Promise<InternalNote> {
    return this.post<InternalNote>(API_ENDPOINTS.users.internalNotes(clientUserId), body);
  }

  async updateNote(
    clientUserId: string,
    noteId: string,
    body: UpdateInternalNoteBody
  ): Promise<InternalNote> {
    return this.patch<InternalNote>(
      API_ENDPOINTS.users.internalNote(clientUserId, noteId),
      body
    );
  }

  async deleteNote(clientUserId: string, noteId: string): Promise<void> {
    await this.delete<void>(API_ENDPOINTS.users.internalNote(clientUserId, noteId));
  }
}

export const internalNotesService = new InternalNotesService();

export const NOTE_TITLE_MAX = 255;
export const NOTE_CONTENT_MAX = 10000;

export const notePreview = (content: string): string =>
  content.length > 120 ? `${content.slice(0, 120).trimEnd()}…` : content;

export const formatNoteDate = (iso: string): string =>
  new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso));

// TODO: re-enable creator-only checks when permissions are finalized
export const canModifyNote = (
  _note: InternalNote,
  _loggedInUserId: string | number | undefined
): boolean => true;
